import React, { useState } from "react";
import { CustomSecondaryInput } from "../../Core/Components/CustomInput";

const Screen3 = ({ setScreen, details, setDetails }) => {
  const [error, setError] = useState("");

  const handleContinue = () => {
    const vehicles = Number(details.vehicles);

    if (!Number.isInteger(vehicles) || vehicles <= 0) {
      setError("Please enter a valid number");
      return;
    }

    setScreen(4);
  };

  return (
    <div className="flex flex-col">
      <h1 className="font-poppins text-2xl text-background-white font-semibold text-center">
        Fleet information
      </h1>

      <p className="my-4 font-poppins text-sm font-normal text-background-white-hover text-center">
        How many vehicles are currently in your fleet?
      </p>

      <CustomSecondaryInput
        value={details.vehicles}
        onChange={(e) => {
          setDetails({ ...details, vehicles: e.target.value });
          setError("");
        }}
      />

      {error ? (
        <p className="mt-2 font-poppins text-xs font-normal text-background-white-hover">
          {error}
        </p>
      ) : null}

      <button
        type="button"
        className="mt-[50px] w-full h-[42px] py-3 rounded-md bg-yellow hover:bg-yellow-dark disabled:cursor-not-allowed"
        // onClick={() => setScreen(4)}
        onClick={handleContinue}
        disabled={details.vehicles === ""}
      >
        <p className="font-poppins text-xs font-medium">Continue</p>
      </button>
    </div>
  );
};

export default Screen3;
